import { RECAPTCHA_V2_KEY, RECAPTCHA_V2_KEY_CI, RECAPTCHA_V3_KEY, RECAPTCHA_V3_KEY_CI, } from "../consts/recaptcha";
import { isCiHost } from "./router";
export const getCaptchaV3Key = () => {
    return isCiHost() ? RECAPTCHA_V3_KEY_CI : RECAPTCHA_V3_KEY;
};
export const getCaptchaV2Key = () => {
    return isCiHost() ? RECAPTCHA_V2_KEY_CI : RECAPTCHA_V2_KEY;
};
export const getCaptchaV3 = async (key = getCaptchaV3Key()) => {
    return await window?.grecaptcha?.execute?.(key, { action: "checkout" });
};
